import React from 'react'

import {useRouter} from 'next/router'
import {PrivacyTermKorean} from '@feature/common/components/terms/Privacy/PrivacyTermKorean'
import {PrivacyTermEnglish} from '@feature/common/components/terms/Privacy/PrivacyTermEnglish'
import Head from 'next/head'
import {useTranslation} from '@lib/intl/useTranslations'
import PageConfig from '@component/layouts/PageConfig/PageConfig'
import useScreenLog from '@hook/useScreenLog'
import TermsNavTabs from '../components/TermsNavTabs'
import {getMessages} from '@lib/intl/intl'

const PrivacyTermPage: React.FC = () => {
    const t = useTranslation()
    const {} = useScreenLog({pageName: 'term_privacy'})
    const language = useRouter().locale

    return (
        <PageConfig mainClassName={'bg-white dark:bg-bg_dark_background'}>
            <Head>
                <title>{t('privacyRule.page.title')}</title>
            </Head>
            <div className={'layout-desktop default_page_padding'}>
                <TermsNavTabs />
                {language == 'ko' ? <PrivacyTermKorean /> : <PrivacyTermEnglish />}
            </div>
        </PageConfig>
    )
}

export const getStaticProps = async ({locale}) => ({
    props: {
        messages: await getMessages(locale || 'en'),
    },
})

export default PrivacyTermPage
